<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/vehicle";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Vehicles",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('vehicles.singular')) }},
    resourceRoute: {default: 'vehicles'},
    modelVariable: {default: 'vehicle'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('vehicles.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('vehicles.plural')),
          href: "/vehicles",
        },
        {
          text: this.$t("Create New"),
          href: "/vehicles/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      return this.$axios.post('/vehicles', value);
    }
  }
}
</script>
